import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/contexts/AuthContext";
import { ApiError } from "@/lib/api/client";
import { learningCoursesApi } from "@/lib/api/learningCourses";

export const learningCoursesQueryKey = (
  tenantId: string | null | undefined,
  userId: string | null | undefined,
) => ["learning-courses", tenantId ?? "unresolved", userId ?? "unresolved"] as const;

/** Enrollment-authorized directory, independent of the ranked Home projection. */
export function useLearningCourses(enabled = true) {
  const { me } = useAuth();
  const query = useQuery({
    queryKey: learningCoursesQueryKey(me?.tenant_id, me?.user_id),
    enabled: enabled && Boolean(me?.tenant_id && me?.user_id),
    queryFn: learningCoursesApi.list,
    retry: (failureCount, error) =>
      error instanceof ApiError && error.status >= 400 && error.status < 500
        ? false
        : failureCount < 1,
  });
  const refused = query.error instanceof ApiError
    && [401, 403, 404].includes(query.error.status);
  return {
    ...query,
    data: refused || !enabled ? undefined : query.data,
    isNoSeat: query.error instanceof ApiError && query.error.status === 404,
  };
}
